import * as theme from './theme';
export function getStatusColor(status) {
  if (status === 'N/A') return 'black';
  const normalizedStatus = status.toLowerCase();
  if (normalizedStatus === 'active' || normalizedStatus === 'success' || normalizedStatus === 'completed' || normalizedStatus === 'online') {
    return '#6fff3d'; // green
  }
  if (normalizedStatus === 'failure' || normalizedStatus === 'failed') {
    return '#e85050'; // red
  }
  if (normalizedStatus === 'pending' || normalizedStatus === 'running' || normalizedStatus === 'in_progress' || normalizedStatus.includes('waiting')) {
    return '#99d9f7'; // cyan
  }
  if (normalizedStatus === 'queued' || normalizedStatus === 'deploying') {
    return '#f9ea3b'; // yellow
  }
  if (normalizedStatus === 'restoring') {
    return '#ff9900'; // orange
  }
  if (normalizedStatus === 'offline') {
    return '#eaeaea';
  }
  if (normalizedStatus === 'deleted') {
    return 'white';
  }
  if (normalizedStatus === 'error_deleting') {
    return theme.colors.background.status.error_deleting;
  }
  if (normalizedStatus === 'error_suspending') {
    return theme.colors.background.status.error_suspending;
  }
  if (normalizedStatus === 'deleting') {
    return theme.colors.background.status.deleting;
  }
  if (normalizedStatus === 'deleted') {
    return theme.colors.background.status.deleted;
  }
  if (normalizedStatus === 'suspending') {
    return theme.colors.background.status.suspending;
  }
  if (normalizedStatus === 'suspended') {
    return theme.colors.background.status.suspended;
  }
  return 'black';
}